import { fetchWithAuth } from './apiUtils';
import { API_URL } from '../constants/api';

const TEMPLATES_API_URL = `${API_URL}/templates/subscriptions`;

/**
 * Obtiene todas las plantillas de mensajes de suscripción.
 * @returns {Promise<any>}
 */
export const getSubscriptionTemplates = async () => {
    return fetchWithAuth(TEMPLATES_API_URL);
};

/**
 * Actualiza una plantilla de mensaje de suscripción.
 * @param {string} templateId El ID de la plantilla a actualizar.
 * @param {object} templateData Los datos a actualizar (message_body, is_active, description).
 * @returns {Promise<any>}
 */
export const updateSubscriptionTemplate = async (templateId, templateData) => {
    const { message_body, is_active, description } = templateData;
    return fetchWithAuth(`${TEMPLATES_API_URL}/${templateId}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ message_body, is_active, description }),
    });
};

/**
 * Actualiza múltiples plantillas de mensajes de suscripción a la vez.
 * @param {Array<object>} templates - Un array de objetos de plantilla.
 * @returns {Promise<any>}
 */
export const updateSubscriptionTemplates = async (templates) => {
    return fetchWithAuth(TEMPLATES_API_URL, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ templates }),
    });
}; 